exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AssociateAccountInProgress_subtitle_2iZT {\n  margin-bottom: 40px;\n}\n\n.AssociateAccountInProgress_popupButton_20yu {\n  margin: 0 15px;\n\n  width: 11em;\n}\n\n.AssociateAccountInProgress_spinner_-dB8 {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n", ""]);

// exports
exports.locals = {
	"subtitle": "AssociateAccountInProgress_subtitle_2iZT",
	"popupButton": "AssociateAccountInProgress_popupButton_20yu",
	"spinner": "AssociateAccountInProgress_spinner_-dB8"
};